<template>
  <div >
    <AppHeader />
    <div v-if="loaded" class="profile">
      <div
        class="profile__preview"
      >
        <v-container
          class="profile__preview-inner"
        >
          <v-layout
            row
            class="white--text"
          >
            <v-flex
              xs7
              class="profile__info"
            >
              <div class="profile__about">
                <v-avatar
                  :size="100"
                  color="grey lighten-4"
                  class="profile__avatar"
                >
                  <img
                    v-if="user.avatar"
                    :src="user.avatar"
                    alt="avatar"
                  >
                  <i
                    v-else
                    class="fas fa-user fa-3x"
                    style="color: #212121"
                  />
                </v-avatar>
                <h3 class="profile__about-title">
                  {{ user.first_name }} {{ user.last_name }}
                </h3>
                <div>{{ user.office }}</div>
              </div>
              <div class="profile__email">
                <div>{{ user.email }}</div>
              </div>
            </v-flex>
            <v-flex
              xs5
              class="profile__activities"
            >
              <div class="profile__activities-item">
                <h3 class="profile__activities-title teal--text text--lighten-2">
                  NMG Miles
                </h3>
                <div class="profile__activities-value">
                  {{ user.total_nmg_miles }}
                </div>
              </div>
              <div class="profile__activities-item">
                <h3 class="profile__activities-title teal--text text--lighten-2">
                  Team
                </h3>
              <router-link v-if="user.user_team[0]" class="profile__activities-value" style="word-break: break-all;" :to="{ name: 'team', params: { id: user.user_team[0].id }}">
                  <v-btn outline round color="teal" small class="profile__team_btn" style="height: unset; padding: 5px 15px;">{{ user.user_team[0].name }}</v-btn>
              </router-link>
              <span v-else>No team</span>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-container v-if="isProfileOwner">
        <v-layout row>
          <v-flex md12>
            <v-btn
              large
              round
              outline
              color="grey darken-1"
              @click.stop="editProfileDialogOpen"
              style="width: 150px"
            >
              Edit profile
            </v-btn>
            <v-btn
            @click="logout"
              large
              round
              outline
              color="grey darken-1"
              style="width: 150px"
            >
              Logout
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
     <!-- <v-container>
        <v-layout row>
          <v-flex md12>
            <h3 class="app-title">
              Team
              {{ user.user_team[0].name }}
              members
            </h3>

            <swiper :options="swiperOption">
              <swiper-slide
                v-for="member in user.user_team[0].members"
                :key="member.id"
                class="profile__slider-item"
              >
                <v-avatar
                  :size="60"
                  color="amber darken-3"
                  class="profile__slider-avartar"
                >
                  <img
                    v-if="member.avatar"
                    :src="member.avatar"
                    alt="avatar"
                  >
                  <i
                    v-else
                    class="fas fa-user fa-2x mt-3"
                    style="color: #212121"
                  />
                </v-avatar>

                <span class="profile__slider-name">{{ member.short_name }}</span>
              </swiper-slide>
            </swiper>
          </v-flex>
        </v-layout>
      </v-container>-->
   <!--   <v-container v-if="isTeamOwner">
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
          >
            <v-btn

              large
              round
              outline
              color="grey darken-1"
              @click.stop="editTeamImageDialog = true"
              style="width: 150px"
            >
              Edit image
            </v-btn>
            <v-btn
                      
              large
              round
              outline
              color="grey darken-1"
              @click.stop="editTeamMembersDialog = true"
              style="width: 150px"
            >
              Edit members
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>-->
      <v-container>
        <v-layout>
          <v-flex
            xs12
          >
            <h3 class="app-title">Last activities</h3>
            <div class="profile-statistics">
              <table class="profile-statistics__table">
                <tr>
                  <th class="profile-statistics__table-heading">
                    Activity
                  </th>
                  <th
                    class="profile-statistics__table-heading"
                  >
                    Amount
                  </th>
                  <th
                    class="profile-statistics__table-heading"
                  >
                    Date
                  </th>
                   <th
                   v-if="isProfileOwner"
                    class="profile-statistics__table-heading"
                  >
                    Action
                  </th>
                </tr>
                <tr v-for="activities_log in user.user_activity"
                    :key="activities_log.id">

                  <td class="profile-statistics__table-cell">
                    {{activities_log.activity}}
                  </td>
                  <td class="profile-statistics__table-cell">
                    {{activities_log.points}} {{activities_log.input}}
                  </td>
                  <td class="profile-statistics__table-cell">
                    {{activities_log.date_record}}
                  </td>
                  <td v-if="isProfileOwner" class="profile-statistics__table-cell">
                    <v-btn @click="trackDeleteConfirmDialogOpen(activities_log)" flat icon color="red">
                      <v-icon>remove_circle</v-icon>
                    </v-btn>

                  </td>
                  
                 </tr>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="trackDeleteConfirmDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"><center>Confirm to delete {{track.activity}}</center></v-card-title>
        <v-card-actions>
          <v-layout align-center justify-space-around>
          <v-btn color="red" flat @click="trackDeleteConfirmDialog = false">Disagree</v-btn>
          <v-btn color="green darken-1"  flat @click="trackDeleteConfirmDialogSave">Agree</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
        v-model="editProfileDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div
          class="edit-dialog__inner"
        >
          <v-toolbar
            fixed
            dark
            color="dark"
          >
            <v-btn
              icon
              dark
              @click="editProfileDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit profile</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                flat
                @click="editProfileDialogSave"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-form>
                  <div class="edit-dialog__avatar">
                    <v-avatar
                      :size="150"
                      color="grey lighten-4"
                      class="profile__avatar"
                    >
                      <img
                        v-if="user.avatar"
                        :src="user.avatar"
                        alt="avatar"
                      >
                      <i
                        v-else
                        class="fas fa-user fa-5x"
                        style="color: #212121"
                      />
                    </v-avatar>
                    <v-btn
                      color="teal lighten-2"
                      @click='pickFile'
                      flat
                      class="edit-dialog__button"
                    >
                      Change photo
                    </v-btn>
                    <input
                      name="avatar"
                      type="file"
                      style="display: none"
                      ref="changeProfileImage"
                      accept="image/*"
                      @change="onFilePicked"
                    >
                  </div>
                  <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="First name"
                    :error-messages="error['first_name']"
                    prepend-inner-icon="fas fa-user fa-1x"
                    v-model="userForm.first_name"
                  />
                  <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="Last name"
                    prepend-inner-icon="fas fa-user fa-1x"
                    :error-messages="error['last_name']"
                    v-model="userForm.last_name"
                  />
                  <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="Email"
                    prepend-inner-icon="far fa-envelope fa-1x"
                    v-model="userForm.email"
                    :error-messages="error['email']"
                  />
                  {{error['detail']}}
              <!--   <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="New password"
                    type="password"
                    v-model="profileForm.password"
                    prepend-inner-icon="fas fa-key fa-1x"
                  />
                  <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="New password again"
                    type="password"
                    v-model="profileForm.repassword"
                    prepend-inner-icon="fas fa-key fa-1x"
                  />-->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>
     <!-- <v-dialog
        v-model="editTeamImageDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div
          class="edit-dialog__inner"
        >
          <v-toolbar
            fixed
            dark
            color="dark"
          >
            <v-btn
              icon
              dark
              @click="editTeamImageDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team image</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                flat
                @click="editTeamImageDialogSave"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-form>
                  <div class="edit-dialog__avatar">
                    <v-avatar
                      :size="150"
                      color="grey lighten-4"
                      class="profile__avatar"
                    >
                      <img
                        v-if="user.user_team[0].avatar"
                        :src="user.user_team[0].avatar"
                        alt="avatar"
                      >
                      <i
                        v-else
                        class="fas fa-user fa-5x"
                        style="color: #212121"
                      />
                    </v-avatar>
                    <v-btn
                      color="teal lighten-2"
                      @click='pickFile'
                      flat
                      class="edit-dialog__button"
                    >
                      Change photo
                    </v-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="changeProfileImage"
                      accept="image/*"
                      @change="onFilePicked"
                    >
                  </div>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>
      <v-dialog
        v-model="editTeamMembersDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div
          class="edit-dialog__inner"
        >
          <v-toolbar
            fixed
            dark
            color="dark"
          >
            <v-btn
              icon
              dark
              @click="editTeamMembersDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team members</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                flat
                @click="editTeamMembersDialogSave"
              >
                Remove
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-form>
                  <table class="edit-dialog__table">
                    <tr>
                      <th
                        class="edit-dialog__table-heading edit-dialog__table-row-checkbox"
                      >
                        <v-checkbox
                          color="teal lighten-2"
                        />
                      </th>
                      <th
                        class="edit-dialog__table-heading"
                      >
                        Member
                      </th>
                    </tr>
                    
                    <tr  v-for="member in user.user_team[0].members"
                          :key="member.id">
                      <td
                        class="edit-dialog__table-row-checkbox"
                      >
                        <v-checkbox
                        v-model="membersToDelete"
                        v-bind:value="member.id"
                          color="teal lighten-2"
                        />
                      </td>
                      <td>
                        <v-avatar
                          :size="25"
                          color="amber darken-3"
                          class="mr-2"
                        >
                          <img
                            v-if="member.avatar"
                            :src="member.avatar"
                            alt="avatar"
                          >
                          <i
                            v-else
                            class="fas fa-user fa-sm"
                            style="color: #212121"
                          />
                        </v-avatar>
                        <span>{{member.short_name}}</span>
                        
                      </td>
                    </tr>
                  </table>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>-->

      <BottomNavigation />
    </div>
     <div v-else >
    <v-progress-linear :indeterminate="true"></v-progress-linear>
  </div>
  </div>
  
  
</template>

<script>
  import AppHeader from '../components/AppHeader';  
  import BottomNavigation from "../components/BottomNavigation";

  import "swiper/dist/css/swiper.css";

  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import { mapGetters } from "vuex";

  export default {
    name: "Profile",
    components: {
      AppHeader,
      BottomNavigation,
      swiper,
      swiperSlide
    },
    data() {
      return {
        editProfileDialog: false,
        editTeamImageDialog: false,
        editTeamMembersDialog: false,
        trackDeleteConfirmDialog: false,
        track: '',
        loaded: false,
        user_activity: false,
        selectedFile: '',
        membersToDelete: [],
        userForm: {},
        swiperOption: {
          slidesPerView: 7,
          spaceBetween: 20,
          // init: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 10,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 8,
              spaceBetween: 20
            },
            640: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            }
          }
        }
      };
    },
    computed: {
      ...mapGetters(
        'user', ['user', 'getCurrentUser', 'error', 'getStatus'],
        ),
      isTeamOwner: function(){
        console.log(this.user)
       return this.user.user_team[0].owner === this.user.id;
      },
      isProfileOwner: function() {
        const user_id = localStorage.getItem('user_id');
        return parseInt(this.user.id, 10) === parseInt(user_id, 10);
        //return false;
      },
    },
    mounted() {
      const user_id = this.$route.params.id;
      this.$store.dispatch('user/getUser', user_id).then(() => {
          this.loaded = true;
          })
          .catch(err => {
            
            });

    },
    methods: {
      trackDeleteConfirmDialogOpen: function(track){
        this.trackDeleteConfirmDialog = true;
        this.track = track;
      },
      trackDeleteConfirmDialogSave: function(){
        this.$store.dispatch('user/deleteTrack', this.track.id).then(() => {
         this.trackDeleteConfirmDialog= false;
         })
         .catch(err => {
           this.trackDeleteConfirmDialog = true;
           });
      },
      editTeamMembersDialogSave: function(){
        let formData = new FormData();
        const members = [];
        this.user.user_team[0].members.map(i => members.push(i.id ));
        self = this
        const members2 = members.filter(function(obj) { return self.membersToDelete.indexOf(obj) == -1; });
        members2.map(i => formData.append('members', i ));
       this.$store
       .dispatch('user/updateTeam',  formData).then(() => {
         this.editTeamMembersDialog= false;
         })
         .catch(err => {
           this.editTeamMembersDialog = true;
           });
      },
      logout: function(){
        this.$store
        .dispatch('authentication/logout')
      },
      editTeamImageDialogSave: function(){
        let formData = new FormData();
        if (this.selectedFile){

          formData.append('avatar', this.selectedFile )
        }
        this.$store
        .dispatch('user/updateTeamAvatar',  formData)
        .then(() => {
          this.editTeamImageDialog = false;
          })
          .catch(err => {
            this.editTeamImageDialog = true;
            });
      },
      editProfileDialogOpen: function(){
        this.editProfileDialog = true;
        this.userForm = {...this.user};
      },
      editProfileDialogSave: function (){
        const formData = new FormData();
        formData.append('first_name', this.userForm.first_name);
        formData.append('last_name', this.userForm.last_name);
        formData.append('email', this.userForm.email);
        if (this.selectedFile){
          formData.append('avatar',  this.selectedFile )
        }
        this.$store.dispatch('user/updateUser',  formData).then(() => {
          this.editProfileDialog = false;
          }).catch(err => {
            this.editProfileDialog = true;
            });
      },
      pickFile () {
        this.$refs.changeProfileImage.click ()
      },
      onFilePicked (e) {
        const files = e.target.files;
        this.selectedFile = event.target.files[0];
      }
    }
  }
  
</script>

<style scoped>
  .profile {
    padding-bottom: 100px;
  }

  .profile__preview {
    background-color: #212121;
  }

  .profile__preview-inner {
    padding: 30px 45px;
  }

  .profile__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 230px;
  }

  .profile__avatar {
    margin-bottom: 15px;
  }

  .profile__about {
  }

  .profile__about-title {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .profile__activities {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .profile__activities-item {
    text-align: center;
    position: relative;
  }

  .profile__activities-title {
    font-family: "Roboto", sans-serif;
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: 15px;
  }

  .profile__activities-value {
    font-weight: bold;
    text-decoration: none;
    color: white;
  }

  .profile__slider-item {
    text-align: center;
  }

  .profile__slider-avartar {
    border: 3px solid;
    padding: 3px;
    background-color: #fff !important;
    display: block;
    box-shadow: 0 1px 5px #fc9667;
    margin-bottom: 5px;
  }

  .profile__slider-name {

  }

  .edit-dialog {

  }
  
  .edit-dialog__inner {
    background-color: #212121;
    min-height: 100vh;
    padding-top: 90px;
  }

  .edit-dialog__title {
    text-align: center;
    font-size: 24px;
  }

  .edit-dialog__avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
    overflow: hidden;
  }

  .edit-dialog__button {
    width: 100%;
    height: 56px;
  }

  .edit-dialog__table {
    width: 100%;
    color: #fff;
    text-align: left;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  .edit-dialog__table-heading {
    border-bottom: 1px solid #fff;
  }

  .edit-dialog__table-row-checkbox {
    width: 45px;
  }

  .profile-statistics {
    padding: 0 15px;
  }
  .profile-statistics__table {
    width: 100%;
    text-align: left;
    border-spacing: 0px;
    border-collapse: collapse;
  }


  .profile-statistics__table-heading {
    padding: 5px 0;
    text-align: left;
  }

  .profile-statistics__table-cell {
    padding: 5px 0;
  }
  .v-progress-circular{
    margin: 1rem;
  }
  .profile__team_btn >>> .v-btn__content {
    flex: unset !important;
    white-space: unset !important;
  }
</style>

